<template>
  <div class="form-row" v-if="!isdeleted">
    <div class="col-md-2 mb-3">
      <v-text-field
        :label="$t('models.nguyenVong.stt')"
        outlined
        dense
        readonly
        :value="stt + 1"
      >
      </v-text-field>
    </div>

    <div class="col-md-9 mb-3">
      <validation-provider
        v-slot="{ errors, valid }"
        :name="$t('models.nguyenVong.truong', { stt: stt + 1 })"
        rules="required"
      >
        <v-autocomplete
          :id="`khaoSat${stt + 1}`"
          required
          :items="truongdaihoc"
          :item-value="(item) => item.ksTruongId"
          :item-text="(item) => `${item.maTruong}: (${item.tenTruong})`"
          :label="`${$t('models.truong.maTruong')} - ${$t(
            'models.truong.tenTruong'
          )}`"
          outlined
          dense
          :success="valid === true"
          :is-valid="!!khaosat.ksTruongId"
          :append-icon="
            valid ? 'mdi-check' : errors[0] ? 'mdi-alert-circle' : ''
          "
          :error="errors[0] ? true : false"
          :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
          v-model="khaosat.ksTruongId"
          @change="updateKhaoSat"
        ></v-autocomplete>
        <span class="text-danger">{{ errors[0] }}</span>
      </validation-provider>
    </div>

    <div class="col-md-1" v-if="length > 1">
      <v-btn
        class="mx-2"
        :name="`delete${stt}`"
        fab
        dark
        small
        color="error"
        @click="deleteKhaoSat(stt)"
      >
        <v-icon dark>mdi-delete</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import KhaoSat from "../js/khaosat";
export default KhaoSat;
</script>

<style lang="scss" scoped></style>
